// src/App.js
import React, { useState, useEffect } from 'react';
import { HashRouter, Routes, Route } from 'react-router-dom'; // Обновили импорт
import LoginPage from './containers/LoginPage';
import Form2Container from './containers/Form2Container';
import Form2Print from './containers/Form2Print';
import Dashboard from './containers/Dashboard';
import ApplicationsList from './containers/ApplicationsList';
import Profile from './containers/Profile';
import NotFound from './containers/NotFound';
import Logout from './services/Logout';
import CandidateCV from './containers/CandidateCV';
import CV from './containers/CV';
import Template1 from './containers/Template1';
import Template2 from './components/CandidateTemplates/Template2';
import Template3 from './components/CandidateTemplates/Template3';
import Template4 from './components/CandidateTemplates/Template4';
import Template5 from './components/CandidateTemplates/Template5';
import Requests from './containers/Request';
import PersonnelData from './containers/PersonnelData';
import AnnualLeaveRequest from './containers/AnnualLeaveRequest';
import ResignationRequest from './containers/ResignationRequest';
import UnpaidLeaveRequest from './containers/UnpaidLeaveRequest';
import EditAnnualLeaveRequest from './containers/EditAnnualLeaveRequest';
import EditUnpaidLeaveRequest from './containers/EditUnpaidLeaveRequest';
import EditResignationRequest from './containers/EditResignationRequest';


function App() {

  return (
    <HashRouter>
      <Routes> {/* Обернули все маршруты в компонент Routes */}
        <Route exact path="/" element={<LoginPage />} /> {/* Используем element prop для рендеринга компонента */}
        <Route path="/dashboard" element={<Dashboard />} />
        {/* <Route path="/cv" element={<Form2Container />} /> */}
        <Route path="/profile" element={<Profile />} />
        <Route path="/form2" element={<Form2Print />} />
        <Route path="/applications" element={<ApplicationsList />} />
        <Route path="/logout" element={<Logout />} />
        <Route path="/candidate" element={<CandidateCV />} />
        <Route path="/cv" element={<CV />} />
        <Route path="/requests" element={<Requests />} />
        <Route path="/personnel_data" element={<PersonnelData />} />
        <Route path="/template1" element={<Template1 />} />
        <Route path="/template2" element={<Template2 />} />
        <Route path="/template3" element={<Template3 />} />
        <Route path="/template4" element={<Template4 />} />
        <Route path="/template5" element={<Template5 />} />
        {/* SD-229348 30.10.2025 Отключение функционала подачи заявлений работодателю
        <Route path="/annual_leave_request" element={<AnnualLeaveRequest />} />
        <Route path="/unpaid_leave_request" element={<UnpaidLeaveRequest />} /> */}
        <Route path="/edit_annual_leave_request" element={<EditAnnualLeaveRequest />} />
        <Route path="/resignation_request" element={<ResignationRequest />} />
        <Route path="/edit_resignation_request" element={<EditResignationRequest />} />
        <Route path="/edit_unpaid_leave_request" element={<EditUnpaidLeaveRequest />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </HashRouter>
  );
}

export default App;
